import api from "./axios";
import { getAuthData } from "./authApi";
import { extractErrorMessage } from "./errorHandler";

// =========================
// دریافت ماشین‌های کاربر
// =========================

export const getCars = async () => {
  const { user } = getAuthData();

  if (!user?.id) {
    throw new Error("User not authenticated");
  }

  try {
    const response = await api.get("/vehicles");
    return response.data;
  } catch (err) {
    throw new Error(extractErrorMessage(err, "خطا در دریافت ماشین‌ها"));
  }
};


// =========================
// دریافت یک ماشین
// =========================

export const getCar = async (carId) => {
  if (!carId) {
    throw new Error("شناسه خودرو مشخص نیست");
  }

  console.log("GET CAR ID:", carId);

  const response = await api.get(
    `/vehicles/${carId}`
  );

  console.log(
    "GET CAR RESPONSE:",
    response.data
  );

  return response.data;
};


// =========================
// ایجاد ماشین
// =========================

export const createCar = async (carData) => {
  const response = await api.post(
    "/vehicles",
    {
      title: carData.title,

      brand:
        carData.brand || "Unknown",

      currentMileage:
        Number(carData.currentMileage) || 0,

      buildYear:
        carData.buildYear
          ? Number(carData.buildYear)
          : null,

      color:
        carData.color || null,

      engineModel:
        carData.engineModel || null,

      chassisNumber:
        carData.chassisNumber || null,

      plate1:
        carData.plate1 || null,

      plate2:
        carData.plate2 || null,

      plate3:
        carData.plate3 || null,

      plateEnd:
        carData.plateEnd || null,

      image:
        carData.image || null,
    }
  );

  return response.data;
};


// =========================
// ویرایش ماشین
// =========================

export const updateCar = async (
  carId,
  carData
) => {
  if (!carId) {
    throw new Error(
      "شناسه خودرو مشخص نیست"
    );
  }

  console.log(
    "UPDATE CAR ID:",
    carId
  );

  console.log(
    "UPDATE CAR DATA:",
    carData
  );

  const response = await api.patch(
    `/vehicles/${carId}`,
    {
      title:
        carData.title,

      brand:
        carData.brand || "Unknown",

      currentMileage:
        Number(carData.currentMileage) || 0,

      buildYear:
        carData.buildYear
          ? Number(carData.buildYear)
          : null,

      color:
        carData.color || null,

      engineModel:
        carData.engineModel || null,

      chassisNumber:
        carData.chassisNumber || null,

      plate1:
        carData.plate1 || null,

      plate2:
        carData.plate2 || null,

      plate3:
        carData.plate3 || null,

      plateEnd:
        carData.plateEnd || null,

      image:
        carData.image || null,
    }
  );

  console.log(
    "UPDATE CAR RESPONSE:",
    response.data
  );

  return response.data;
};


// =========================
// تغییر کیلومتر ماشین
// =========================

export const updateCarMileage = async (
  carId,
  currentMileage
) => {
  if (!carId) {
    throw new Error(
      "شناسه خودرو مشخص نیست"
    );
  }

  if (
    currentMileage === undefined ||
    currentMileage === null ||
    currentMileage === ""
  ) {
    throw new Error(
      "مقدار کیلومتر مشخص نیست"
    );
  }

  console.log(
    "UPDATE MILEAGE CAR ID:",
    carId
  );

  console.log(
    "UPDATE MILEAGE:",
    currentMileage
  );

  const response = await api.patch(
    `/vehicles/${carId}/mileage`,
    {
      currentMileage:
        Number(currentMileage),
    }
  );

  console.log(
    "UPDATE MILEAGE RESPONSE:",
    response.data
  );

  return response.data;
};


// =========================
// حذف ماشین
// =========================

export const deleteCar = async (
  carId
) => {
  if (!carId) {
    throw new Error(
      "شناسه خودرو مشخص نیست"
    );
  }

  console.log(
    "DELETE CAR ID:",
    carId
  );

  const response = await api.delete(
    `/vehicles/${carId}`
  );

  console.log(
    "DELETE CAR RESPONSE:",
    response.data
  );

  return response.data;
};